export function removeProfileNamePoolPrefix(
  profileName: string,
  poolPrefix: string,
) {
  return profileName.startsWith(poolPrefix)
    ? profileName.slice(poolPrefix.length)
    : profileName;
}
